/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import aw_common_awards from '../components/aw_common_awards';
import aw_common_awards_inset from '../components/aw_common_awards_inset';
import aw_common_big_image from '../components/aw_common_big_image';
import aw_common_career_form from '../components/aw_common_career_form';
import aw_common_career_positions from '../components/aw_common_career_positions';
import aw_common_career_recruiter from '../components/aw_common_career_recruiter';
import aw_common_contact_us from '../components/aw_common_contact_us';
import aw_common_contact_us_form from '../components/aw_common_contact_us_form';
import aw_common_contact_us_inset from '../components/aw_common_contact_us_inset';
import aw_common_events_inset from '../components/aw_common_events_inset';
import aw_common_events_normal from '../components/aw_common_events_normal';
import aw_common_events_registration_form from '../components/aw_common_events_registration_form';
import aw_common_events_wide from '../components/aw_common_events_wide';
import aw_common_faq from '../components/aw_common_faq';
import aw_common_faq_inset from '../components/aw_common_faq_inset';
import aw_common_gallery from '../components/aw_common_gallery';
import aw_common_gallery_inset from '../components/aw_common_gallery_inset';
import aw_common_grid_info_3col from '../components/aw_common_grid_info_3col';
import aw_common_grid_info_4col from '../components/aw_common_grid_info_4col';
import aw_common_grid_info_5col from '../components/aw_common_grid_info_5col';
import aw_common_grid_info_inset_image from '../components/aw_common_grid_info_inset_image';
import aw_common_grid_info_inset_text from '../components/aw_common_grid_info_inset_text';
import aw_common_headquarters from '../components/aw_common_headquarters';
import aw_common_hero_banner from '../components/aw_common_hero_banner';
import aw_common_inpage_navigation from '../components/aw_common_inpage_navigation';
import aw_common_insights_inset from '../components/aw_common_insights_inset';
import aw_common_insights_normal from '../components/aw_common_insights_normal';
import aw_common_insights_wide from '../components/aw_common_insights_wide';
import aw_common_modal_provider from '../components/aw_common_modal_provider';
import aw_common_offices from '../components/aw_common_offices';
import aw_common_offices_inset from '../components/aw_common_offices_inset';
import aw_common_page_intro_image from '../components/aw_common_page_intro_image';
import aw_common_page_intro_text from '../components/aw_common_page_intro_text';
import aw_common_partners from '../components/aw_common_partners';
import aw_common_partners_inset from '../components/aw_common_partners_inset';
import aw_common_plainhtml from '../components/aw_common_plainhtml';
import aw_common_promo from '../components/aw_common_promo';
import aw_common_richtext from '../components/aw_common_richtext';
import aw_common_teaserbox_events from '../components/aw_common_teaserbox_events';
import aw_common_teaserbox_images_bottom from '../components/aw_common_teaserbox_images_bottom';
import aw_common_teaserbox_images_left from '../components/aw_common_teaserbox_images_left';
import aw_common_teaserbox_images_right from '../components/aw_common_teaserbox_images_right';
import aw_common_teaserbox_image_inset from '../components/aw_common_teaserbox_image_inset';
import aw_common_teaserbox_image_left from '../components/aw_common_teaserbox_image_left';
import aw_common_teaserbox_image_right from '../components/aw_common_teaserbox_image_right';
import aw_common_teaserbox_text from '../components/aw_common_teaserbox_text';
import aw_common_testimonials from '../components/aw_common_testimonials';
import aw_common_testimonials_inset_image from '../components/aw_common_testimonials_inset_image';
import aw_common_testimonials_inset_text from '../components/aw_common_testimonials_inset_text';
import aw_common_video_modal from '../components/aw_common_video_modal';
import aw_content_slim from '../components/aw_content_slim';
import aw_navigation_footer from '../components/aw_navigation_footer';
import aw_navigation_links from '../components/aw_navigation_links';
import aw_navigation_main from '../components/aw_navigation_main';

const components = new Map();
components.set('aw_common_awards', aw_common_awards);
components.set('aw_common_awards_inset', aw_common_awards_inset);
components.set('aw_common_big_image', aw_common_big_image);
components.set('aw_common_career_form', aw_common_career_form);
components.set('aw_common_career_positions', aw_common_career_positions);
components.set('aw_common_career_recruiter', aw_common_career_recruiter);
components.set('aw_common_contact_us', aw_common_contact_us);
components.set('aw_common_contact_us_form', aw_common_contact_us_form);
components.set('aw_common_contact_us_inset', aw_common_contact_us_inset);
components.set('aw_common_events_inset', aw_common_events_inset);
components.set('aw_common_events_normal', aw_common_events_normal);
components.set('aw_common_events_registration_form', aw_common_events_registration_form);
components.set('aw_common_events_wide', aw_common_events_wide);
components.set('aw_common_faq', aw_common_faq);
components.set('aw_common_faq_inset', aw_common_faq_inset);
components.set('aw_common_gallery', aw_common_gallery);
components.set('aw_common_gallery_inset', aw_common_gallery_inset);
components.set('aw_common_grid_info_3col', aw_common_grid_info_3col);
components.set('aw_common_grid_info_4col', aw_common_grid_info_4col);
components.set('aw_common_grid_info_5col', aw_common_grid_info_5col);
components.set('aw_common_grid_info_inset_image', aw_common_grid_info_inset_image);
components.set('aw_common_grid_info_inset_text', aw_common_grid_info_inset_text);
components.set('aw_common_headquarters', aw_common_headquarters);
components.set('aw_common_hero_banner', aw_common_hero_banner);
components.set('aw_common_inpage_navigation', aw_common_inpage_navigation);
components.set('aw_common_insights_inset', aw_common_insights_inset);
components.set('aw_common_insights_normal', aw_common_insights_normal);
components.set('aw_common_insights_wide', aw_common_insights_wide);
components.set('aw_common_modal_provider', aw_common_modal_provider);
components.set('aw_common_offices', aw_common_offices);
components.set('aw_common_offices_inset', aw_common_offices_inset);
components.set('aw_common_page_intro_image', aw_common_page_intro_image);
components.set('aw_common_page_intro_text', aw_common_page_intro_text);
components.set('aw_common_partners', aw_common_partners);
components.set('aw_common_partners_inset', aw_common_partners_inset);
components.set('aw_common_plainhtml', aw_common_plainhtml);
components.set('aw_common_promo', aw_common_promo);
components.set('aw_common_richtext', aw_common_richtext);
components.set('aw_common_teaserbox_events', aw_common_teaserbox_events);
components.set('aw_common_teaserbox_images_bottom', aw_common_teaserbox_images_bottom);
components.set('aw_common_teaserbox_images_left', aw_common_teaserbox_images_left);
components.set('aw_common_teaserbox_images_right', aw_common_teaserbox_images_right);
components.set('aw_common_teaserbox_image_inset', aw_common_teaserbox_image_inset);
components.set('aw_common_teaserbox_image_left', aw_common_teaserbox_image_left);
components.set('aw_common_teaserbox_image_right', aw_common_teaserbox_image_right);
components.set('aw_common_teaserbox_text', aw_common_teaserbox_text);
components.set('aw_common_testimonials', aw_common_testimonials);
components.set('aw_common_testimonials_inset_image', aw_common_testimonials_inset_image);
components.set('aw_common_testimonials_inset_text', aw_common_testimonials_inset_text);
components.set('aw_common_video_modal', aw_common_video_modal);
components.set('aw_content_slim', aw_content_slim);
components.set('aw_navigation_footer', aw_navigation_footer);
components.set('aw_navigation_links', aw_navigation_links);
components.set('aw_navigation_main', aw_navigation_main);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
